<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Divider orientation="left" class="text-primary">支出信息</Divider>
                <Row :gutter="32">
                    <Col span="12">
                        <FormItem label="项目" prop="project_id">
                            <Select v-model="Forms.project_id" disabled clearable filterable  placeholder="项目">
                                <Option v-for="(item,index) in projectList" :key="index" :value="item.project_id">{{item.name}}({{item.status_name}})</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="采购信息" prop="buyer_id">
                            <Select v-model="Forms.buyer_id" clearable filterable :disabled="is_select"  placeholder="采购信息" class="width-100">
                                <Option v-for="(item,index) in buyerList" :key="index" :value="item.buyer_id">{{item.title}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="采购金额" prop="money">
                            <Input v-model="Forms.money" type="number" clearable placeholder="" :class="Forms.buyer_id?'width-70':'width-100'"/>
                            <span v-if="Forms.buyer_id">&nbsp;<Button type="primary" class="width-27"  ghost @click="getBuyerMoney">获取金额</Button></span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="付款类型" prop="type_id">
                            <Select v-model="Forms.type_id" clearable filterable  placeholder="付款类型" class="width-100">
                                <Option v-for="(item,index) in expendTypeList" :key="index" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                  <Col span="12">
                    <FormItem label="采购清单" prop="image" :rules="[{required: true, type:'array', message: '请上传采购清单', trigger: 'change'}]">
                      <Input v-model="Forms.image[0]" disabled>
                        <template #append>
                          <div class="f-center">
                            <Upload
                                :show-upload-list="false"
                                :action="upload_url"
                                :headers = "{'token': $store.state.token}"
                                :format="['xls','xlsx','rar','zip','doc','docx','txt','docx','jpg','jpeg','png','pdf']"
                                :max-size="50 * 1024"
                                :on-success="handleSuccess"
                                :on-format-error="handleFormatError"
                                :on-exceeded-size="handleMaxSize">
                              <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                            </Upload>
                            <Divider type="vertical" />
                            <a href="javascript:void(0);" @click="FileDelete('image')" class="text-danger"><Icon type="md-trash" />删除</a>
                            <Divider type="vertical" />
                            <a href="javascript:void(0);" @click="FileDownload(Forms.image[0])" class="text-violet"><Icon type="md-download" />下载</a>
                          </div>
                        </template>
                      </Input>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="发票" prop="invoice_image">
                      <Input v-model="Forms.invoice_image[0]" disabled>
                        <template #append>
                          <div class="f-center">
                            <Upload
                                :show-upload-list="false"
                                :action="upload_url"
                                :headers = "{'token': $store.state.token}"
                                :format="['xls','xlsx','rar','zip','doc','docx','txt','docx','jpg','jpeg','png','pdf']"
                                :max-size="50 * 1024"
                                :on-success="handleInvoiceSuccess"
                                :on-format-error="handleFormatError"
                                :on-exceeded-size="handleMaxSize">
                              <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                            </Upload>
                            <Divider type="vertical" />
                            <a href="javascript:void(0);" @click="FileDelete('invoice_image')" class="text-danger"><Icon type="md-trash" />删除</a>
                            <Divider type="vertical" />
                            <a href="javascript:void(0);" @click="FileDownload(Forms.invoice_image[0])" class="text-violet"><Icon type="md-download" />下载</a>
                          </div>
                        </template>
                      </Input>
                    </FormItem>
                  </Col>
                </Row>
                <Divider orientation="left" class="text-primary">收款账户</Divider>
                <Row :gutter="32">
                    <Col span="12">
                        <FormItem label="收款账户" prop="pay_bank_account">
                            <Input v-model="Forms.pay_bank_account" clearable placeholder="" :class="Forms.buyer_id?'width-70':'width-100'"/>
                            <span v-if="Forms.buyer_id">&nbsp;<Button type="primary" class="width-27"  ghost @click="getAccount">自动获取</Button></span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="账户实名" prop="pay_bank_real_name">
                            <Input v-model="Forms.pay_bank_real_name" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户银行" prop="pay_bank_name">
                            <Input v-model="Forms.pay_bank_name" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户地址" prop="pay_bank_address">
                            <Input v-model="Forms.pay_bank_address" clearable placeholder="" />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="收款备注" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="备注信息" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>

        <!-- 预览图片 -->
        <Modal
            v-model="is_view_box"
            title="预览"
            :width="840"
            :mask-closable="true"
            :footer-hide="true"
            @on-cancel="PhotoViewClose()">
            <div class="flex-image-box">
                <img :src="view_url" class="flex-image-box-show">
            </div>
        </Modal>

    </Drawer>
</template>

<script>

import {getProjectSelectList} from "@/apis/project";
import {getBuyerAccount, getBuyerSelectList, getBuyerMoney} from "@/apis/buyer";
import {getExpendConfig, getExpendDetail, saveExpend} from "@/apis/expend";

export default {
    name: 'ExpendIndex',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '项目支出',
            isBox : false,
            expendTypeList: [],
            projectList: [],
            buyerList: [],

            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,
            is_view_box : false,
            view_url : '',
            is_select: false,

            Forms : {
                expend_id: '',
                project_id: '',
                buyer_id: '',
                money: '',
                type_id: '',
                image: [],
                invoice_image: [],
                pay_bank_account: '',
                pay_bank_real_name: '',
                pay_bank_name: '',
                pay_bank_address: '',
                remark: ''
            },
            Rules : {
                project_id: [
                    { required: true, type: 'number',  message: '请选择项目', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                buyer_id: [
                    { required: true, type: 'number',  message: '请选择采购信息', trigger: 'change',  transform(value) { return parseInt(value)}}
                ],
                money: [
                    { required: true, type: 'number',  message: '请输入付款金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
                ],
                type_id: [
                    { required: true, type: 'number',  message: '请选择付款类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                pay_bank_account: [
                    { required: true, message: '请输入收款账户', trigger: 'blur'}
                ],
                pay_bank_real_name: [
                    { required: true, message: '请输入收款账户开户实名', trigger: 'blur'}
                ]
            }
        }
    },
    methods: {
      /**
       功能：图片文件
       time: 2025/12/17 10:48
       **/
      FileDelete(f){
        let that = this;
        that.Forms[f] = [];
      },
      /**
       功能：
       time: 2025/12/19 18:12
       **/
      FileDownload(url){
        let that = this;
        if(url){
          //下载文件
          const fileUrl = that.site_url + url; // 文件的URL地址
          const parts = fileUrl.split('/');
          const fileName = parts[parts.length - 1];
          const link = document.createElement('a');
          link.href = fileUrl;
          link.target = '_blank';
          link.setAttribute('download', fileName);
          link.click();
        }else{
          that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
        }
      },
        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：图片删除
         time: 2025/12/15 10:21
         **/
        PhotoDelete(index){
            let that = this;
            that.Forms.image.splice(index , 1);
        },
        PhotoInvoiceDelete(index){
            let that = this;
            that.Forms.invoice_image.splice(index , 1);
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleSuccess(res){
          let that = this;
          if(res.code === 100){
            this.Forms.image = [res.data.url];
          }else{
            that.$Message.error({ background: true,duration:3, content: res.msg});
          }
        },
      handleInvoiceSuccess(res){
        let that = this;
        if(res.code === 100){
          this.Forms.invoice_image = [res.data.url];
        }else{
          that.$Message.error({ background: true,duration:3, content: res.msg});
        }
      },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | gif 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '图片大小不能超出 10M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleBeforeUpload(){
            let that = this;
            if(that.Forms.image.length >= 10){
                that.$Message.error({ background: true,duration:3, content: '最多只能上传 10 张图' });
                return false;
            }
            return true;
        },
        handleInvoiceBeforeUpload(){
            let that = this;
            if(that.Forms.invoice_image.length >= 10){
                that.$Message.error({ background: true,duration:3, content: '最多只能上传 10 张图' });
                return false;
            }
            return true;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },

        /**
         功能：
         time: 2025/12/26 16:14
         **/
        getAccount(){
            let that = this;
            if(!that.Forms.buyer_id){
                that.$Message.error({ background: true,duration:3, content: '请选择采购信息'});
                return;
            }
            getBuyerAccount(that.Forms.buyer_id).then(e => {
                let data = e.data;
                that.Forms.pay_bank_account = data.bank_account ?? '';
                that.Forms.pay_bank_real_name = data.bank_real_name ?? '';
                that.Forms.pay_bank_name = data.bank_name ?? '';
                that.Forms.pay_bank_address = data.bank_address ?? '';
            })
        },
        getBuyerMoney(){
            let that = this;
            if(!that.Forms.buyer_id){
                that.$Message.error({ background: true,duration:3, content: '请选择采购信息'});
                return;
            }
            getBuyerMoney(that.Forms.buyer_id).then(e => {
                let data = e.data;
                that.Forms.money = data.buyer_money ?? '';
            })
        },

        /**
         功能：
         time: 2025/12/25 16:29
         **/
        GetConfig(project_id){
            let that = this;
            getExpendConfig().then(e=>{
                that.expendTypeList = e.data.expendTypeList ?? [];
            })
            getProjectSelectList().then(e=>{
                that.projectList = e.data ?? [];
            })
            getBuyerSelectList({project_id:project_id}).then(e=>{
                that.buyerList = e.data ?? [];
            })
        },

        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getExpendDetail(id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'project_id' || v === 'buyer_id' || v === 'type_id') {
                        that.Forms[v] = parseInt(data[v]);
                    }else if(v === 'image' || v === 'invoice_image') {
                        that.Forms[v] = data[v] ? data[v] : [];
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
                that.GetConfig(e.data.project_id);
            })
        },
        /**
         功能：
         time: 2025/12/25 16:08
         **/
        add(project_id, name){
            this.isBox = true;
            this.title = typeof name !== 'undefined' ? name + ' - 项目支出': '项目支出';
            this.Forms.project_id = typeof project_id !== 'undefined' ? parseInt(project_id) : '';
            this.GetConfig(project_id);
        },

        /**
         功能：
         time: 2026/1/6 11:44
         **/
        adds(project_id, name, buyer_id){
            this.isBox = true;
            this.title = typeof name !== 'undefined' ? name + ' - 项目支出': '项目支出';
            this.Forms.project_id = typeof project_id !== 'undefined' ? parseInt(project_id) : '';
            this.Forms.buyer_id = typeof buyer_id !== 'undefined' ? parseInt(buyer_id) : '';
            this.is_select = true;
            this.GetConfig(project_id);
        },

        /**
         功能：
         time: 2026/1/6 11:47
         **/
        edit(expend_id){
            this.isBox = true;
            this.is_select = true;
            if(expend_id) this.GetDetail(expend_id);
        },
        /**
         功能：
         time: 2025/12/25 17:38
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveExpend(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/27 10:00
         **/
        FormReset(){
            this.isBox = false;
            this.title = '项目支出';
            this.$refs['Forms'].resetFields();
            this.Forms.expendTypeList = [];
            this.Forms.projectList = [];
            this.is_select = false;
            this.Forms.buyerList = [];
            this.Forms.expend_id = '';
            this.Forms.image = [];
            this.Forms.invoice_image = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
